// 404.js
import React from "react";
import Config from "../Config.json";
import { Helmet } from "react-helmet-async";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TITLE = "AI inside life | " + Config.SITE_TITLE;
const DESC = "Create a React App from an HTML Website.";

const NotFound = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const createLocalizedLink = (path) => `/${currentLang}${path}`;
  return (
    <main className="error404Margin">
      <Helmet>
        <title>Page Not Found</title>
        <link rel="canonical" href="{CANONICAL}"></link>
        <meta name="description" content={DESC} />
        <meta name="theme-color" content={Config.THEME_COLOR} />
      </Helmet>
      <div className="err404 mt-6">
        <h1 className="Error404">ERROR 404</h1>
        <h2>{t("Error404_Title")}</h2>
        <p>{t("Error404_SubTitle")}................</p>
        <img id="err404" src="../images/error404.gif" alt="ERROR_404"></img>

        <p>
          {t("Error404_Go_To_Back")}
          <NavLink
            className="nav-link err404Link"
            to={createLocalizedLink("/Home")}
          >
            {t("Site_1")}
          </NavLink>
        </p>
      </div>
    </main>
  );
};

export default NotFound;
